import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  // ❌ NE PAS définir Content-Type ici - laissez Axios le gérer automatiquement
});

api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    // ✅ CORRECTION CRITIQUE : Gérer automatiquement le Content-Type
    if (config.data instanceof FormData) {
      // Si c'est FormData, supprimer le Content-Type pour laisser Axios le gérer
      delete config.headers['Content-Type'];
    } else if (!config.headers['Content-Type']) {
      // Sinon, utiliser application/json par défaut
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
